<template>
  <div>
    <!-- Default -->
    <mds-notification-container v-if="showAlert" class="alert-box-user">
      <mds-notification
        key="sizing-medium"
        size="medium"
        variation="error"
        :dismiss-delay="dismissVal"
        title="Unauthorized"
        role="alert"
        @mds-notification-dismissed="closePopup"
      >
        User has restricted access
      </mds-notification>
    </mds-notification-container>
    <div class="container">
      <div class="mds-level-6-heading">
        Disclaimer
      </div>
      <div class="paragraph">
        Pursuant to SEC Rule 17g-5(a)(3) of the Exchange Act, Morningstar DBRS
        maintains certain information for rating actions taken on structured
        finance instruments covered under the Rule on this password-protected
        website and makes it available to NRSROs who meet the criteria to access
        it in accordance with the Rule.<br /><br />
        This website may only be viewed by an authorized representative of an
        organization that has been granted a username and password by
        Morningstar DBRS.<br /><br />
        To request access to this website, please send an email request to
        <a href="mailto:CreditCompliance@morningstar.com" class="my-link"
          >CreditCompliance@morningstar.com</a
        >
        and include the certification set forth in Rule 17g-5(e).
      </div>
      <div class="mds-level-6-heading">
        Reporting Concerns
      </div>
      <div class="paragraph">
        If an Authorized User experiences difficulties accessing transaction
        information on this website, or has concerns about the completeness or
        timeliness of information relating to transactions on the 17g5 list,
        please submit the concerns in writing to the Morningstar DBRS Designated
        Compliance Officer at
        <a href="mailto:CreditCompliance@morningstar.com" class="my-link"
          >CreditCompliance@morningstar.com</a
        >
      </div>
      <mds-button
        variation="primary"
        class="center_align"
        @click.prevent="redirectToLogin()"
      >
        Proceed To Sign In
      </mds-button>
    </div>
  </div>
</template>

<script>
import { MdsNotification, MdsNotificationContainer } from "@mds/notification";
import { MdsButton } from "@mds/button";
import { redirectToCreditLogin } from "@/apis/user-authentication";

export default {
  name: "Disclaimer",
  components: {
    MdsButton,
    MdsNotification,
    MdsNotificationContainer,
  },
  data() {
    return {
      showAlert: false,
      dismissVal: 300000,
    };
  },
  mounted() {
    window.addEventListener("unload", this.removeStorage);
    if (localStorage.getItem("user_access")) {
      this.showAlert = true;
    }
  },
  methods: {
    redirectToLogin() {
      localStorage.removeItem("user_access");
      const successUrl = new URL(window.location.href + "deals-listing");
      redirectToCreditLogin(successUrl);
    },
    closePopup() {
      this.showAlert = false;
    },
    removeStorage() {
      localStorage.removeItem("user_access");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/reset";
@import "@/styles/constants";

.mds-level-6-heading {
  @include mds-level-6-heading();
  margin-bottom: $mds-space-3-x;
}

.container {
  margin-top: 82px;
  width: 620px;
  margin-left: auto;
  margin-right: auto;
  height: 500px;
}

.paragraph {
  @include mds-body-text-s();
  margin-bottom: $mds-space-5-x;

  .my-link {
    @include mds-link($underline: false, $visited-styles: false);
    color: #007cc2;
  }
}

.center_align {
  margin-left: 35%;
  margin-right: 35%;
}

.alert-box-user {
  margin-top: $mds-masthead-height + $mds-space-3-x;
  max-width: 350px;
}

.mds-notification-container--top-center__mcr-rd {
  margin-left: auto;
  margin-right: auto;
}
</style>
